/**
 * @typedef {function(*): void} PubSubCallback
 */

/* eslint-disable no-var */

/** @type {Record<string, PubSubCallback[]>} */
// @ts-ignore - Global variable for pub/sub system
var subscribers = {};

/**
 * Subscribe to an event
 * @param {string} eventName - The name of the event to subscribe to
 * @param {PubSubCallback} callback - The callback function to execute when the event is published
 * @returns {function(): void} Unsubscribe function
 */
// @ts-ignore - Global function for pub/sub system
var subscribe = function(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter(
      /** @param {PubSubCallback} cb */
      (cb) => {
        return cb !== callback;
      }
    );
  };
};

/**
 * Publish an event to all subscribers
 * @param {string} eventName - The name of the event to publish
 * @param {*} data - The data to pass to subscriber callbacks
 * @returns {void}
 */
// @ts-ignore - Global function for pub/sub system
var publish = function(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach(
      /** @param {PubSubCallback} callback */
      (callback) => {
        callback(data);
      }
    );
  }
};
